module.exports = __webpack_public_path__ + "images/emoji/tiger2.a89a4bc105453f30b2ee.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tiger2.png
// module id = eZSM
// module chunks = 13